<template>
  <div class="home">
    <b-container
      fluid
      class="px-5"
    >
        <b-row>
            <b-col
                sm="12"
                md="7"
                lg="9"
                xl="9"
            >
                <h2
                    class="mb-4"
                >
                    Online-Präsentation des Projektseminars
                </h2>
                <p
                    v-html="staticParts.leaflet"
                    class="lga-leaflet"
                /> 
            </b-col>
        </b-row>
      <b-row>
        <b-col
          sm="12"
          md="7"
          lg="9"
          xl="9"
          order-md="1"
          order-sm="2"
        >
          <h3
            class="mb-4"
            v-if="!searchResult"
          >
            Künstler*innen
          </h3>
                   <h3
            class="mb-4"
            v-else
          >
            Suchergebnis für "{{searchString}}"
          </h3>       
          <div
            class=""
          > 
            <p
              class="border py-2 px-3"
              v-if="!searchResult"
            >
              Sortierung: {{ sortDisplay }}<span v-html="filterDisplay"/>
            </p>
          </div>
          <div
            v-if="filteredArtists.length === 0 && displayArtists.length !== 0"
          >
            <p>Keine Künstler zu diesem Filterkriterium erfasst.</p>
          </div>
          <div
            v-if="displayArtists.length === 0"
          >
            <p>Künstlerdaten werden geladen ...</p>
          </div>
          <!-- Ausgabe Filter-Modus -->
          <b-row
            v-if="!searchResult"
          >
            <b-col
              md="6"
              lg="6"
              xl="4"
              v-for="(artist, index) in filteredArtists"
              :key="index"
              class="p-2 "
            >
              <ArtistCard 
                :artist="artist"
              />
            </b-col>
          </b-row>
          <!-- Ausgabe Suchergebnisse -->
          <b-row
            v-else
          >
            <b-col
              md="6"
              lg="6"
              xl="4"
              v-for="(artist, index) in searchResult"
              :key="index"
              class="p-2 "
            >
              <ArtistCard 
                :artist="artist"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          sm="12"
          md="5"
          lg="3"
          xl="3"
          order-md="2"
          order-sm="1"
          class="border-left pl-4"
        >
          <template
            v-if="!searchResult"
          >
            <h3
              class="mb-4"
            >
              Sortieren und Filtern
            </h3>        
            <div
              class="py-1"
            >
              <p><strong> Sortieren nach:</strong></p>
              <b-button
                squared 
                variant="outline-secondary"
                class="mb-2 mr-2 small lga-sort-button lga-sort-button-text"
                :disabled="sortSettings.first.criterium === 'name'"
                @click="setSortCriterium('name')"
              >
              Namen
              </b-button>     
              <b-button
                squared 
                variant="outline-secondary"
                class="mb-2 mr-2 small lga-sort-button lga-sort-button-text"
                :disabled="sortSettings.first.criterium === 'dateOfBirth'"
                @click="setSortCriterium('dateOfBirth')"
              >
                Geburtsdatum
              </b-button>
              <br>
              <b-button
                squared 
                variant="outline-secondary"
                class="small lga-sort-button lga-sort-button-arrow"
                v-if="sortSettings.first.direction === 'desc'"
                @click="setSortDirection('asc')"
              >
              <span>&uarr;</span>
              </b-button>
                  
              <b-button
                squared 
                variant="outline-secondary"
                class=" small lga-sort-button lga-sort-button-arrow"
                v-if="sortSettings.first.direction === 'asc'"
                @click="setSortDirection('desc')"
              >
                <span>&darr;</span>
              </b-button>
              <p
                class="mt-3"
              >
                <strong>Filtern nach:</strong>
              </p>
              <p>Geburtsjahr</p>
              <vue-slider
                ref="slider"
                v-model="DOBValue"
                :enable-cross="false"
                :tooltip="'focus'"
                :max="DOBmax"
                :min="DOBmin"
              />
              <p>Ausgewählter Zeitraum: {{ DOBValue[0] }}&ndash;{{ DOBValue[1] }} </p>
            </div>

          </template>
          <template
            v-else
          >
            <h3
              class="mb-4"
            >
              Suchen
            </h3>        
            <div
              class="py-1"
            >
              <b-form @submit.prevent="search">
                <b-form-input size="sm" class="" placeholder="Suche" v-model="localSearchString"></b-form-input>
                <b-button size="sm" class="mt-2" type="submit">Suche</b-button>
                <b-button size="sm" class="ml-2 mt-2" type="submit" variant="outline-secondary" @click="resetSearch">alle Künstler*innen</b-button>
              </b-form>
            </div>
          </template>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import ArtistCard from '@/components/subparts/ArtistCard'

export default {
  name: 'home',
  components: {
    ArtistCard
  },
  data () {
    return {
      // Slider
      DOBValue: [1860,1925],
      DOBmax: 1925,
      DOBmin: 1860,
      localSearchString: ''
    }
  },
  methods: {
    ...mapActions({
      setSortDirection: 'setSortDirection',
      setSortCriterium: 'setSortCriterium',
      setSearchString: 'setSearchString',
      resetSearch: 'resetSearch'
    }),
    search() {
      this.setSearchString(this.localSearchString)
      this.$store.dispatch('searchItems', this.localSearchString)
      this.localSearchString = null
    }
  },
  computed: {
    ...mapGetters({
      staticParts: 'getStaticParts',
      sortSettings: 'getSortSettings',
      displayArtists: 'getDisplayArtists',
      searchResult: 'getSearchResult',
      searchString: 'getSearchString'
    }),
    filteredArtists() {
      let filteredArtists = []
      let DOBmin = this.DOBValue[0]
      let DOBmax = this.DOBValue[1]
      filteredArtists = this.displayArtists.filter(a => a.dateOfBirthFilter >= DOBmin && a.dateOfBirthFilter <= DOBmax)
      return filteredArtists
    },
    sortDisplay () {
      let output = ''
      let criteriumOutput = ''
      let directionOutput = ''
      let criterium = this.sortSettings.first.criterium
      let direction = this.sortSettings.first.direction
      if (criterium === 'name') {
        criteriumOutput = 'Name'
      }
      if (criterium === 'dateOfBirth') {
        criteriumOutput = 'Geburtsdatum'
      }
      if (direction === 'asc') {
        directionOutput = 'aufsteigend'
      }
      if (direction === 'desc') {
        directionOutput = 'absteigend'
      }
      output = `${criteriumOutput}, ${directionOutput}`
      return output
    },
    filterDisplay () {
      let output=''
      if (this.DOBValue[0] !== this.DOBmin || this.DOBValue[1] !== this.DOBmax) {
        output = `Geburtsjahr: ${this.DOBValue[0]} &ndash; ${this.DOBValue[1]}`
      }
      if (output !== '') {
        output = ' | Filter: ' + output
      }
      return output
    }
  },
  created () {
    
  }
}
</script>
<style scoped>
.chosen {
  background-color: #ccc;
  color: #666;
}
.lga-leaflet {
    column-count: 2;
    column-gap: 1.4rem;
  }
@media (max-width: 1400px) {
  .lga-leaflet {
    column-count: 1;
  }
}
.lga-sort-button {
  padding: .15rem .6rem;
}
</style>
